/**
 * 
 */



L.Publication = L.Class.extend({
	
	statics: {
		STATUT:{draft:'draft',pending:'pending',future:'future',publish:'publish',private:'private',trash:'trash',autoDraft:'auto-draft',inherit:'inherit'},
		VISIBILITY:{public:'public',password:'password',private:'private'}
	},
	

	initialize: function(source){
		
		this._source = source;
		this._post={};
		this._post.post_status = L.Publication.STATUT.autoDraft;
		this._post.post_visibility = L.Publication.VISIBILITY.public;
		this._post.post_date = this._getFormattedDate();

	},
	
	setPostId: function(id){
		this._post.ID = id;
	},
	
	getPostId: function(){
		return this._post.ID;
	},
	
	setParent: function(post_parent){
		this._post.post_parent = post_parent;
	},
	
	getParent: function(){
		return this._post.post_parent;
	},
	
	setStatut: function(statut){
		this._post.post_status=statut;
	},
	
	getStatut: function(){
		return this._post.post_status ;
	},
	
	setDate: function(date){
		this._post.post_date=date;	
	},
	
	getDate: function(){
		return this._post.post_date;
	},
	
	setDateGMT: function(date){
		this._post.post_date_gmt=date;
		
	},
	
	getDateGMT: function(){
		return this._post.post_date_gmt;
	},
	
	setVisibility: function(visibility){
		this._post.post_visibility = visibility;
		if ((this._post.post_visibility == L.Publication.VISIBILITY.password) && (!this._post.post_password)){
			this._post.post_password= "";
		}
	},
	
	getVisibility: function(){
		return this._post.post_visibility;
	},
	
	setPassword: function(password){
		this._post.post_password = password;
	},
	
	getPassword: function(password){
		return this._post.post_password;
	},
	
	_getFormattedDate : function (){	
		var dateOBj =  new Date();
		return dateOBj.getFullYear()+'-'+( '00' + parseInt(dateOBj.getMonth()+1) ).slice( -2 )+'-'+( '00' + parseInt(dateOBj.getDate()) ).slice( -2 )+' '+dateOBj.getHours()+':'+dateOBj.getMinutes()+':'+dateOBj.getSeconds(); //today (local time)
	}
})


L.publication = function (source) {
    return new L.Publication(source);
};

L.ImageOverlay.include({
	bindPublication: function(publication){
		if (publication instanceof L.Publication){
			this.publication = publication;
			publication._source = this;
		}
	},
	
	unbindPublication: function(){
		
		this.publication._source = undefined;
		publicationUnbinded = this.publication;
		this.publication = undefined;
		return publicationUnbinded;
	},
})

L.Marker.include({
	bindPublication: function(publication){
		if (publication instanceof L.Publication){
			this.publication = publication;
			publication._source = this;
		}
	},
	
	unbindPublication: function(){
		
		this.publication._source = undefined;
		publicationUnbinded = this.publication;
		this.publication = undefined;
		return publicationUnbinded;
	},
})


L.ImageOverlay.addInitHook(function (e, i) {
	if (L.Publication) {
		this.publication = new L.Publication(this);
	}
});

L.Marker.addInitHook(function () {
	if (L.Publication) {
		this.publication = new L.Publication(this);
	}
});

